
import {
  defineComponent, onBeforeMount, reactive,
} from 'vue';
import { Modal } from 'ant-design-vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import Icone from '@/core/components/Icone.vue';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import Paginacao from '@/core/components/Tela/Paginacao.vue';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import BuscaGeral from '@/core/components/BuscaAvancada/BuscaGeral.vue';
import ColunaGrade from '@/core/components/Tela/ColunaGrade.vue';
import { ITelaOperacao } from '@/core/models/ITelaOperacao';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { ETipoPermissao } from '@/models/Enumeradores/MeuSistema/Usuarios/ETipoPermissao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import { EVinculoEmpresa } from '@/core/models/Enumeradores/EEVinculoEmpresa';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import storeSistema from '@/store/storeSistema';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import { useGradeBase } from '@/core/composables/GradeBase';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import Card from '@/core/components/Tela/Card.vue';
import { IDTOUsuarioPermissoes } from '@/models/DTO/MeuSistema/Usuarios/IDTOUsuarioPermissoes';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import ServicoParametros from '@/servicos/MeuSistema/ServicoParametros';
import ConhecimentoTransporteModal from './ConhecimentoTransporteModal.vue';
import { IBuscaAvancada } from '@/core/models/BuscaAvancada/IBuscaAvancada';
import { IParametrosConsulta } from '@/core/models/Consulta/IParametrosConsulta';
import servicoConhecimentoTransporte from '@/servicos/Fiscal/ServicoConhecimentoTransporte';
import { ICte } from '@/models/Entidades/Compras/ConhecimentoTransporte/ICte';

export default defineComponent({
  name: 'ConhecimentoTransporteIndex',
  components: {
    Icone,
    Card,
    ColunaGrade,
    MensagemSemDados,
    BuscaGeral,
    TituloPadrao,
    PreviewPdf,
    ConhecimentoTransporteModal,
    Paginacao,
  },
  setup(props) {
    const servicoParametro = new ServicoParametros();
    servicoParametro.requisicaoSistema();
    servicoConhecimentoTransporte.requisicaoSistema();
    const {
      telaBase, obterPermissoes, preencherEmpresasDisponiveis, verificaConceitoParaApresentarEmpresas,
      defineEmpresasSelecionadasComPermissao, filtrarPermissaoDadosUsuarioMultiEmpresas,
      apresentarMensagemSucesso, apresentarMensagemErro, apresentarMensagemAlerta,
      adicionarAtalho, removerAtalho, preencherDadosRota, salvarPreferenciasFiltros, salvarPreferenciasOrdenacao,
      salvarPreferenciasGrade,
    } = useTelaBase();

    const { gradeBase, redefinirPersonalizacaoColunas } = useGradeBase();

    const state = reactive({
      empresaSelecionada: 0,
      exibirPersonalizarColunas: false,
      exibirModal: false,
      conhecimentoTransporte: [] as Array<any>,
      operacaoLancamento: {} as ITelaOperacao,
      autorizacoes: [] as IDTOUsuarioPermissoes[],
      atualizarGrid: false,
      arquivosPdf: [] as IArquivoPdf[],
      buscaAvancada: {
        filtros: [],
        filtroSelecionado: undefined,
        tipoDadoFiltroSelecionado: 0,
        ordenacao: [],
        condicoes: [],
        condicaoSelecionada: undefined,
        valoresSelecionados: [],
        valorSelecionado: {} as any,
        valores: [],
        primeiroValor: undefined,
        segundoValor: undefined,
        filtrosAdicionados: [],
        chaveFiltrosAdicionados: 0,
        pesquisaRealizadaComFiltrosAdicionados: false,
      } as unknown as IBuscaAvancada,
      buscaRapida: '',
      conhecimentoTransporteSelecionado: {} as Partial<ICte>,
    });
    telaBase.apresentarEmpresas = false;

    function preencherColunas() {
      gradeBase.colunasMobile = [
        {
          title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 1, visible: false,
        },
        {
          title: 'Número', dataIndex: 'numeroConhecimento', key: 'Numero', position: 2, visible: true,
        },
      ];

      gradeBase.colunasPadrao = [
        {
          title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 1, visible: false,
        },
        {
          title: 'Número', dataIndex: 'numeroConhecimento', key: 'NumeroConhecimento', position: 2, visible: true, width: 30, ellipsis: true, customRenderRow: ECustomRenderRow.LinkAcao, align: 'left',
        },
        {
          title: 'Data de Emissão', dataIndex: 'dataEmissao', key: 'DataEmissao', position: 3, visible: true, customRenderRow: ECustomRenderRow.MascararData, ordering: false, width: 30, align: 'center',
        },
        {
          title: 'Valor', dataIndex: 'valor', key: 'Valor', position: 4, visible: true, customRenderRow: ECustomRenderRow.MascararFracionado, align: 'center', width: 50,
        },
        {
          title: 'Chave de Acesso', dataIndex: 'chaveAcesso', key: 'ChaveAcesso', position: 5, visible: true, ellipsis: true, width: 120,
        },
        {
          title: 'Ações', key: 'acoes', position: 6, visible: true, width: 75, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
        },
      ];
    }

    async function buscarConhecimentoTransporte() {
      state.conhecimentoTransporte = [];
      gradeBase.codigosSelecionados = [];
      gradeBase.filtrosAplicados = [];
      (state.buscaAvancada.filtrosAdicionados ?? []).forEach((item) => {
        gradeBase.filtrosAplicados.push(item.filtro);
      });

      const parametrosConsulta = {} as IParametrosConsulta;
      parametrosConsulta.empresas = [state.empresaSelecionada];
      parametrosConsulta.numeroPagina = gradeBase.paginacao.current;
      parametrosConsulta.qtdeRegistrosPagina = gradeBase.paginacao.pageSize;
      parametrosConsulta.qtdeRegistrosTotal = gradeBase.paginacao.total;
      parametrosConsulta.ordenacao = Array<string>();
      parametrosConsulta.valorBuscaRapida = state.buscaRapida;

      telaBase.ordenacaoSelecionada.forEach((ordenacao) => {
        parametrosConsulta.ordenacao.push(`${ordenacao.identificador}|${ordenacao.ordem}`);
      });

      if (!UtilitarioGeral.validaLista(gradeBase.ordenacaoSelecionada)) {
        parametrosConsulta.ordenacao.push('CodigoConhecimentoTransporte|ASC');
      }

      telaBase.carregando = true;
      try {
        const listaPaginada = await servicoConhecimentoTransporte.buscaAvancada(parametrosConsulta, gradeBase.filtrosAplicados);
        state.conhecimentoTransporte = listaPaginada?.dados ?? [];
        if (listaPaginada?.metaData) {
          gradeBase.paginacaoApi = listaPaginada.metaData;
          console.log('Lista de Conhecimento de Transporte carregada com sucesso. ', listaPaginada);
        }
      } catch (error) {
        apresentarMensagemErro('Não foi possível carregar os conhecimentos de transporte.');
      } finally {
        telaBase.carregando = false;
      }
    }

    async function atualizarSelecaoEmpresas() {
      telaBase.empresasSelecionadas = [] as number[];
      telaBase.empresasSelecionadas.push(state.empresaSelecionada);
      telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas(telaBase.empresasSelecionadas);
      await buscarConhecimentoTransporte();
    }

    async function aplicarFiltros() {
      gradeBase.paginacao.current = 1;
      await buscarConhecimentoTransporte();
    }

    function incluir() {
      state.operacaoLancamento = {} as ITelaOperacao;
      state.operacaoLancamento.tipoPermissaoDados = EPermissaoDados.Incluir;
      state.operacaoLancamento.listaPermissoesDados = telaBase.listaPermissoesDados;
      state.operacaoLancamento.codigoRegistro = 0;
      state.operacaoLancamento.empresaSelecionada = state.empresaSelecionada;
      state.conhecimentoTransporteSelecionado = {} as Partial<ICte>;
      state.exibirModal = true;
    }

    function editar(codigoRegistro: number) {
      state.operacaoLancamento = {} as ITelaOperacao;
      state.operacaoLancamento.tipoPermissaoDados = EPermissaoDados.Alterar;
      state.operacaoLancamento.listaPermissoesDados = telaBase.listaPermissoesDados;
      state.operacaoLancamento.codigoRegistro = codigoRegistro;
      state.operacaoLancamento.empresaSelecionada = state.empresaSelecionada;
      state.conhecimentoTransporteSelecionado = state.conhecimentoTransporte.find((o) => o.codigo === codigoRegistro) || {} as Partial<ICte>;
      state.exibirModal = true;
    }

    async function atualizarListagemAposAlteracao() {
      gradeBase.paginacao.current = 1;
      await buscarConhecimentoTransporte();
    }

    function confirmarExclusao(record: any) {
      if (!record || !record.codigo) {
        apresentarMensagemErro('Registro inválido para exclusão.');
        return;
      }
      Modal.confirm({
        title: 'Confirmação',
        content: 'Deseja excluir este registro?',
        onOk: async () => {
          try {
            const retorno = await servicoConhecimentoTransporte.excluir(record.codigo, state.empresaSelecionada);

            if (retorno?.status === 1) {
              apresentarMensagemSucesso(retorno.mensagem || 'Registro excluído com sucesso.');
              state.atualizarGrid = true;
              await atualizarListagemAposAlteracao();
              return;
            }

            if (retorno?.status === 2) {
              apresentarMensagemAlerta(retorno.mensagem || 'A exclusão retornou alerta.');
              return;
            }

            apresentarMensagemErro(retorno?.mensagem || 'Erro ao excluir o registro.');
          } catch (error) {
            apresentarMensagemErro('Erro ao excluir o registro.');
          }
        },
        onCancel: () => { /* nada a fazer */ },
      });
    }

    async function imprimir(tipoArquivoRelatorio:ETipoArquivo, codigoRegistro?:number) {
      gradeBase.filtrosAplicados = [];

      const parametrosConsulta = {} as IParametrosConsulta;
      parametrosConsulta.empresas = [state.empresaSelecionada];
      parametrosConsulta.numeroPagina = 1;
      parametrosConsulta.qtdeRegistrosPagina = 0;
      parametrosConsulta.qtdeRegistrosTotal = 0;
      parametrosConsulta.ordenacao = Array<string>();

      gradeBase.ordenacaoSelecionada.forEach((item) => {
        parametrosConsulta.ordenacao.push(`${item.identificador}|${item.ordem}`);
      });
      let codigosSelecionados: number[] = [];
      if (codigoRegistro !== undefined && codigoRegistro > 0) {
        codigosSelecionados.push(codigoRegistro);
      } else {
        codigosSelecionados = gradeBase.codigosSelecionados;
      }
    }

    onBeforeMount(async () => {
      state.empresaSelecionada = storeSistema.getters.codigoEmpresaOperacao();
      gradeBase.layoutMobile = storeSistema.state.layoutMobile;
      preencherDadosRota();
      await obterPermissoes(ETipoPermissao.Dados);
      await preencherEmpresasDisponiveis();
      await defineEmpresasSelecionadasComPermissao();
      verificaConceitoParaApresentarEmpresas();
      telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas([state.empresaSelecionada]);
      if (telaBase.propriedadesConsulta.length > 0) {
        state.buscaAvancada.filtros = telaBase.propriedadesConsulta.filter((item) => item.filtro === true);
        state.buscaAvancada.ordenacao = telaBase.propriedadesConsulta.filter((item) => item.ordenacao === true);
      }
      state.buscaAvancada.filtrosAdicionados = [];
      state.buscaAvancada.chaveFiltrosAdicionados = 0;
      if (UtilitarioGeral.validaLista(state.buscaAvancada.filtrosAdicionados)) {
        await aplicarFiltros();
      }
      preencherColunas();
      gradeBase.colunas = gradeBase.colunasPadrao;
      gradeBase.paginacao.current = 1;
      gradeBase.paginacao.pageSize = 10;
      gradeBase.paginacao.pageSizeOptions = ['10', '20', '50', '100', '500'];
      await buscarConhecimentoTransporte();
    });

    async function atualizarInformacoesTela() {
      state.atualizarGrid = true;
    }

    function textoCodigosSelecionados():string {
      if (gradeBase.codigosSelecionados.length === 1) { return '1 - Registro selecionado'; }

      if (gradeBase.codigosSelecionados.length > 1) { return `${gradeBase.codigosSelecionados.length} - Registros selecionados`; }
      return '';
    }
    return {
      state,
      props,
      window,
      EVinculoEmpresa,
      ETipoArquivo,
      ECustomRenderRow,
      UtilitarioMascara,
      UtilitarioData,
      UtilitarioGeral,
      storeSistema,
      telaBase,
      gradeBase,
      incluir,
      editar,
      confirmarExclusao,
      aplicarFiltros,
      buscarConhecimentoTransporte,
      imprimir,
      atualizarSelecaoEmpresas,
      adicionarAtalho,
      removerAtalho,
      atualizarInformacoesTela,
      atualizarListagemAposAlteracao,
      textoCodigosSelecionados,
      salvarPreferenciasFiltros,
      salvarPreferenciasOrdenacao,
      salvarPreferenciasGrade,
      redefinirPersonalizacaoColunas,
    };
  },
});
